import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';

import { HomeSection } from '#client/components/HomeSection';
import { CardList, CardItem } from '#client/components/NextUp/NextUp.style';

import { EnterpriseNextUpCard } from './EnterpriseNextUpCard';
import useEnterpriseNextUp from './hooks/useEnterpriseNextUp';

function EnterpriseNextUp() {
  const { formatMessage } = useIntl();
  const { cards, loading } = useEnterpriseNextUp();

  if (!loading && cards.length === 0) {
    return null;
  }

  return (
    <HomeSection
      title={(
        <Text size="xl" weight="medium" loading={loading}>
          {!loading && <FormattedMessage id="dashboard.enterpriseNextUp.title" />}
        </Text>
      )}
    >
      {loading ? (
        <Skeleton data-testid="enterprise-next-up-skeleton" height={300} />
      ) : (
        <CardList component="ul">
          {cards.map((card, idx) => (
            <CardItem
              component="li"
              key={card.type}
            >
              <EnterpriseNextUpCard
                ctaType={card.ctaType}
                ctaUrl={card.ctaUrl}
                description={formatMessage({ id: card.descriptionId })}
                estimate={card.estimate}
                highlight={cards.length > 1 && idx === 0}
                imageUrl={card.imageUrl}
                isLocked={card.isLocked}
                title={formatMessage({ id: card.titleId })}
              />
            </CardItem>
          ))}
        </CardList>
      )}
    </HomeSection>
  );
}

export default EnterpriseNextUp;
